<template>
  <div class="video-player-wrap" v-if="play">
    <videoPlayer
      class="video-player-box"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
      customEventName="customstatechangedeventname"
      @ended="onPlayerEnded($event)"
      @ready="playerReadied"
      >
    </videoPlayer>
    <a v-if="Number(options.closeEnable) === 1" href="javascript:;" class="btn-close" @click="onPlayerEnded"></a>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player/dist/vue-video-player'
import videojs from 'video.js'

// 播放m3u8需要注意：
// 注意点1：需要引入videojs并绑定到window上
window.videojs = videojs
// 注意点2：引入依赖
require('videojs-contrib-hls/dist/videojs-contrib-hls.js')

require('video.js/dist/video-js.css')

export default {
  name: 'PopupVideoPlayer',
  components: { videoPlayer },
  props: {
    hideLoading: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    play () {
      return this.playerOptionsReady && this.hideLoading
    }
  },
  data () {
    return {
      player: null,
      videoPlayer: null,
      playerOptionsReady: false,
      playerOptions: {
        controls: false,
        muted: true,
        // playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'application/x-mpegURL',
          src: ''
        }],
        autoplay: true,
        hls: true
      }
    }
  },
  created () {
    this.playerOptions.sources[0].src = this.options.url || 'http://ss-global-cdn.akamaized.net/assets/video/2022-01-17/5d85e8639fb5f99515eb23d64baae8b9/chunk/playlist.m3u8'
    this.$nextTick(() => {
      this.playerOptionsReady = true
    })
    document.addEventListener('click', this.openVolume)
  },
  methods: {
    onPlayerEnded () {
      this.$utils.consoleLog('onPlayerEnded')
      this.$emit('onVideoEnded')
    },
    playerReadied (player) {
      this.player = player
      this.videoPlayer = this.$refs.videoPlayer
    },
    openVolume () {
      this.player && this.player.muted(false)
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.openVolume)
  }
}
</script>

<style lang="scss" scoped>
.video-player-wrap{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.video-player-box{
  width: 100%;
  height: 100%;
  & > ::v-deep(div){
    width: 100% !important;
    height: 100% !important;
  }
}
.btn-close{
  width: 61px;
  height: 60px;
  position: absolute;
  top: 50px;
  right: 50px;
  background: url(~@/assets/img/close_ib_popup.png) no-repeat center center;
  background-size: contain;
  z-index: 10000;
}
</style>
